var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-start"},[_c('h1',{staticClass:"text-sm  flex items-center inline-block  px-3 py-1 rounded-lg leading-20 text-white"},[_vm._t("default",[_vm._v("Fraud")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }